import React from 'react'
import EmptyState from './EmptyState';

const SkeletonCard = () => (
    <div className="col-md-6 col-lg-4 col-xl-3 placeholder-glow">
        <div className="list-grid-skel-card">
            <div className="d-flex justify-content-between mb-3">
                <span className="placeholder col-5 rounded"></span>
                <span className="placeholder col-3 rounded-pill"></span>
            </div>
            <span className="placeholder col-8 mb-2 rounded"></span>
            <span className="placeholder col-6 mb-2 rounded"></span>
            <span className="placeholder col-4 rounded"></span>
        </div>
    </div>
);

const Grid = ({ data = [], loading, isRefreshing = false, gridLayout, emptyReason = "empty", onAddNew, addLabel, onClearSearch, onClearFilters }) => {
    const isInitialLoading = loading && !isRefreshing;
    const emptyAction = {
        empty: { actionLabel: addLabel, onAction: onAddNew },
        search: { actionLabel: onClearSearch ? "Clear search" : undefined, onAction: onClearSearch },
        filter: { actionLabel: onClearFilters ? "Clear filters" : undefined, onAction: onClearFilters },
    }[emptyReason] || {};

    if (isInitialLoading) {
        return (
            <div className="row g-3">
                {[...Array(8)].map((_, i) => <SkeletonCard key={i} />)}
            </div>
        );
    }

    if (!data.length) {
        return <EmptyState reason={emptyReason} actionLabel={emptyAction.actionLabel} onAction={emptyAction.onAction} />;
    }

    return (
        <div className={`list-grid-wrap ${isRefreshing ? "is-refreshing" : ""}`}>
            <div className="row g-3 align-items-stretch list-grid-scroll">
                {data.map((item, idx) => (
                    <div key={item.id || item._id || idx} className="col-md-6 col-lg-4 col-xl-3">
                        {gridLayout(item)}
                    </div>
                ))}
            </div>
            {isRefreshing ? <div className="list-refresh-bar" aria-hidden="true" /> : ""}
        </div>
    );
};

export default Grid;
